// ANNI — Countdown für Drop-Sektion.
// <anni-countdown data-end="ISO-8601"> tickt sekündlich; bei Ablauf wird
// innerhalb der Sektion .anni-drop__state--counting versteckt und
// .anni-drop__state--live gezeigt (kein Reload nötig).
class AnniCountdown extends HTMLElement {
  connectedCallback() {
    this.endTime = Date.parse(this.dataset.end || '');
    if (Number.isNaN(this.endTime)) return;

    this.fields = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.endTime - Date.now();

    if (remaining <= 0) {
      clearInterval(this.interval);
      this.goLive();
      return;
    }

    const seconds = Math.floor(remaining / 1000);
    this.render({
      days: Math.floor(seconds / 86400),
      hours: Math.floor((seconds % 86400) / 3600),
      minutes: Math.floor((seconds % 3600) / 60),
      seconds: seconds % 60,
    });
  }

  render(values) {
    for (const [unit, value] of Object.entries(values)) {
      const field = this.fields[unit];
      if (!field) continue;
      const text = String(value).padStart(2, '0');
      // Nur bei Änderung schreiben — vermeidet unnötige Repaints
      if (field.textContent !== text) field.textContent = text;
    }
  }

  goLive() {
    this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 });

    const section = this.closest('.anni-drop');
    if (section) {
      // Drop-Sektion: Zustände tauschen
      section.querySelector('.anni-drop__state--counting')?.setAttribute('hidden', '');
      section.querySelector('.anni-drop__state--live')?.removeAttribute('hidden');
    } else {
      // Anderer Kontext (z. B. Password-Seite): Timer dezent ausblenden
      this.setAttribute('hidden', '');
    }
  }
}

if (!customElements.get('anni-countdown')) {
  customElements.define('anni-countdown', AnniCountdown);
}
